import { UserAffiliation } from '../user-affiliation';
import { QueryablePagedRequest } from './queryable-paged-request';

export class UserAffiliationSearchRequest extends QueryablePagedRequest {
  public providerCollectionID?: number;
  public isEnterpriseUserFlag?: boolean;
  public accountStatus: string;
}
